import { FC, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { CenteredCardView, CenteredLoader, Link } from '@vs-online-only-app/ui';
import { Typography } from '@mui/material';
import { AuthenticationContext } from '@vs-online-only-app/state';
import LoginForm from './LoginForm';

const isIframed = window.top !== window;

const LoginView: FC = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);

  if (isIframed && !isAuthenticated) {
    return (
      <CenteredLoader>
        <Typography variant="body1">Authenticating</Typography>
      </CenteredLoader>
    );
  }

  const body = <LoginForm />;
  const footer = (
    <Typography variant="body1" color="textSecondary">
      Don't have an account? <Link to="/account/create">Create one</Link>
    </Typography>
  );

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <CenteredCardView body={body} footer={footer} />;
};

export default LoginView;
